import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ActivateAccountBody } from "@shared-kernel/application/ports/public/public-repository";

export const activateAccount = createAsyncThunk<void, ActivateAccountBody, { extra: Partial<Dependencies> }>(
  "users/activateAccount",
  async (body: ActivateAccountBody, { extra: { publicRepository } }) => {
    return publicRepository!.activateAccount(body);
  },
);
